export default __webpack_public_path__ + "static/media/ezshop.87d071b5.png";